


import React from "react";
import "./UsersPanel.scss"; // reuse the same table/card styles

export default function CompaniesPanel() {
    // placeholder: no companies yet
    const companies = [];

    return (
        <div className="cu-page">
            <div className="cu-shell">
                {/* Header */}
                <header className="cu-header">
                    <h1>Companies</h1>
                    {/* right-side actions can go here later */}
                </header>

                {/* Table */}
                <div className="cu-table">
                    <div className="cu-head">
                        <div className="cu-cell cu-cell--check">
                            <input type="checkbox" aria-label="select all" disabled />
                        </div>
                        <div className="cu-cell">Company</div>
                        <div className="cu-cell">Members</div>
                        <div className="cu-cell">Orders</div>
                        <div className="cu-cell">Amount Spent</div>
                        <div className="cu-cell">Payment</div>
                        <div className="cu-cell">Action</div>
                    </div>

                    {/* Empty state: show Coming Soon in-table using existing muted style */}
                    <div className="cu-loading" style={{ textAlign: "center", padding: 24 }}>
                        <div className="ud-title" style={{ fontSize: 16 }}>Coming soon</div>
                        <p style={{ color: '#64748b', marginTop: 8 }}>
                            Manage companies as groups, and assign employees under each company.
                        </p>
                        <p style={{ color: '#94a3b8', marginTop: 4, fontSize: 13 }}>
                            (We’ll list companies on the left and show company details here.)
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}